import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { CarryOutOutlined, FormOutlined } from "@ant-design/icons";

import { Button, PageHeader, Popconfirm, Space, Table } from "antd";

import type { ColumnsType } from "antd/lib/table";
import RoleStore, { RoleInfo } from "../../../stores/Admin/RoleStore";
import RoleAddDialog from "./dialogs/RoleAddDialog";
import RoleEditDialog from "./dialogs/RoleEditDialog";
import RoleBindAppDialog from "./dialogs/RoleBindAppDialog";

const RolesPage: React.FC = (props) => {
  const { roles, pagination } = RoleStore;
  const [visibles, setVisibles] = useState<{ [key: string]: any }>({
    roleAdd: false,
    roleEdit: false,
    bindApp: false,
  });
  const updateVisibles = (
    key: string,
    value: any,
    info: {
      id: number;
      name: string;
      //  code?: string;
      des?: string;
    } = {
      id: 0,
      name: "",
      // code: "",
      des: "",
    }
  ) => {
    visibles[key] = value;
    setVisibles({ ...visibles });
    if (info?.id !== undefined) setRoleInfo({ ...roleInfo, ...info });
  };

  const [roleInfo, setRoleInfo] = useState<{
    id: number;
    name: string;
    // code?: string;
    des?: string;
  }>({
    id: 0,
    name: "",
    // code: "",
    des: "",
  });

  useEffect(() => {
    RoleStore.getRoleList();
    return () => {
      RoleStore.setPagination({ total: 0, pageNum: 1, pageSize: 10 });
    };
  }, []);
  const paginationProps = {
    showSizeChanger: false,
    showQuickJumper: false,
    total: pagination.total, // 数据总数
    pageSize: pagination.pageSize, // 每页条数
    current: pagination.pageNum, // 当前页码
    onChange: (pageNum: number, pageSize: number) => {
      RoleStore.setPagination({ ...pagination, pageNum, pageSize });
      RoleStore.getRoleList(pageNum, pageSize);
    },
    showTotal: (total: number) => {
      return `共 ${total} 条`;
    },
  };

  const columns: ColumnsType<RoleInfo> = [
    {
      title: "序号",
      dataIndex: "num",
      key: "num",
      render: (text, record, index) => (
        <span>
          {(paginationProps.current - 1) * paginationProps.pageSize +
            Number(index) +
            1}
        </span>
      ),
    },
    {
      title: "分组名称",
      dataIndex: "name",
      key: "name",

      render: (text) => <a>{text}</a>,
    },
    {
      title: "分组描述",
      dataIndex: "des",
      key: "des",
      render: (text) => <span>{`${text ? text : "一"}`}</span>,
    },
    {
      title: "更新时间",
      dataIndex: "updatedTime",
      key: "updatedTime",
      render: (text) => (
        <span>{`${text ? new Date(text).toLocaleString() : "一"}`}</span>
      ),
    },

    {
      title: "操作",
      key: "action",
      render: (_, record) => {
        const info = {
          ...roleInfo,
          ...record,
        };
        return (
          <Space size="middle">
            <a
              onClick={() => {
                updateVisibles("roleEdit", true, info);
              }}
            >
              编辑
            </a>
            <a
              onClick={() => {
                updateVisibles("bindApp", true, info);
                RoleStore.getAppByRoleId(record.id);
              }}
            >
              应用绑定
            </a>
            <Popconfirm
              title="确定删除该分组吗?"
              onConfirm={() => RoleStore.removeRole(info.id)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <a href="#">删除</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  return (
    <>
      <PageHeader title="应用分组" />

      <div className={styles.content}>
        <div style={{ marginBottom: 16 }}>
          <Button
            shape="round"
            type="primary"
            onClick={() => {
              updateVisibles("roleAdd", true);
            }}
          >
            新建应用
          </Button>
        </div>
        <div className={styles.table_content}>
          <Table
            columns={columns}
            dataSource={roles}
            pagination={paginationProps}
          />
        </div>
      </div>
      <RoleAddDialog
        visible={visibles.roleAdd}
        close={() => updateVisibles("roleAdd", false)}
      />
      <RoleEditDialog
        visible={visibles.roleEdit}
        roleInfo={roleInfo}
        close={() => updateVisibles("roleEdit", false)}
      />
      <RoleBindAppDialog
        visible={visibles.bindApp}
        roleInfo={roleInfo}
        close={() => updateVisibles("bindApp", false)}
      />
    </>
  );
};

export default observer(RolesPage);
